//**************************************************************************************************
//  サイドナビ
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';

import { TranslatePipe } from "@ngx-translate/core";

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AppConst } from '../../app-const';

import { SessionService } from '../service/session.service';
import { Session }  from '../../class/session';

import { FireSysAdmin } from '../../class/fire/sys_admin';
import { FireOpAdmin } from '../../class/fire/op_admin';
import { FireOpUser } from '../../class/fire/op_user';
import { FireGroup } from '../../class/fire/group';
import { FireOpr } from '../../class/fire/opr';
//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-sidenav',
  imports: [
    CommonModule,
    TranslatePipe,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatToolbarModule,
  ],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css'
})
//==================================================================================================
//
//==================================================================================================
export class SidenavComponent {
  //================================================================================================
  //  @ViewChild  （HTML内の要素との紐付けを宣言）
  //============================|===================================================================
  @Output() sidenavClose        = new EventEmitter();
  @Output() sidenavToggle       = new EventEmitter();
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  isLogin                       : boolean                 = false;
  isAuthS                       : boolean                 = false;                                  //  システム管理者
  isAuthO                       : boolean                 = false;                                  //  OP管理者
  isAuthU                       : boolean                 = false;                                  //  一般ユーザー
  isGroup                       : boolean                 = false;                                  //  グループ
  isOpr                         : boolean                 = false;                                  //  OPレジストリ
  //------------------------------------------------------------------------------------------------
  sessionUid                    : string | null           = null;                                   //  セッション情報：UID
  sessionSysAdmin               : FireSysAdmin | null     = null;                                   //  セッション情報：システム管理者
  sessionOpAdmin                : FireOpAdmin | null      = null;                                   //  セッション情報：OP管理者
  sessionOpUser                 : FireOpUser | null       = null;                                   //  セッション情報：CAユーザー
  sessionGroup                  : FireGroup | null        = null;                                   //  セッション情報：グループ
  sessionOpr                    : FireOpr | null          = null;                                   //  セッション情報：OPレジストリ
  //================================================================================================
  //  コンストラクタ
  //================================================================================================
  constructor(
    private sessionService: SessionService) { }
  //================================================================================================
  //  初期処理
  //================================================================================================
  ngOnInit(): void {
    this.sessionService.sessionState.subscribe((session: Session)=> {
      if (session) {
        this.isLogin              = session.isLogin;
        this.sessionUid           = session.uid;
        this.sessionSysAdmin      = session.sysAdmin;
        this.sessionOpAdmin       = session.opAdmin;
        this.sessionOpUser        = session.opUser;
        this.sessionGroup         = session.group;
        this.sessionOpr           = session.opr;
        //------------------------------------------------------------------------------------------
        this.isAuthS              = !!this.sessionSysAdmin ?      true : false;
        this.isAuthO              = !!this.sessionOpAdmin ?       true : false;
        this.isAuthU              = !!this.sessionOpUser ?        true : false;
        this.isGroup              = !!this.sessionGroup ?         true : false;
        this.isOpr                = !!this.sessionOpr ?           true : false;
        //------------------------------------------------------------------------------------------
      }
    })
  }
  //================================================================================================
  //  終了処理
  //================================================================================================
  ngOnDestroy(): void {
  }
}
